import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  table: {
    "& tr['data-rbd-placeholder-context-id']": {
      flexGrow: 1,
      flexBasis: 1,
    },
  },
  head: {
    background: '#FBFBFB',
  },
  orderCol: {
    '& .iconContainer': {
      display: 'inline-block',
      verticalAlign: 'inherit',
    },
    borderBottom: '1px solid #E0E0E0',
    minWidth: 78,
  },
  orderIcon: {
    color: '#777',
    display: 'flex',
    alignItems: 'center',
  },
  orderNumber: {
    color: theme.palette.text.subtitle,
    fontSize: theme.typography.pxToRem(13),
    marginLeft: 5,
    verticalAlign: 'inherit',
  },
  col: {
    flexBasis: 1,
    flexGrow: 1,
    borderBottom: '1px solid #E0E0E0',
  },
}));

export default useStyles;
